import type { RootState } from "@/src/common/redux/store";

export const getUser = (state: RootState) => state.auth.user;
export const getIsAuthenticated = (state: RootState) => state.auth.isAuthenticated;
export const getIsProfileComplete = (state: RootState) => !!state.auth.user?.completed_at;
export const getIsStaff = (state: RootState) => state.auth.user?.is_staff === true;
export const getLastUsedAuthMethod = (state: RootState) => state.auth.lastUsedAuthMethod;
export const getRefreshToken = (state: RootState) => state.auth.refreshToken;
export const getImpersonatorId = (state: RootState) => state.auth.impersonatorId;
